// @ts-strict-ignore
import { inject, Injectable } from '@angular/core';
import { ValidatorFn } from '@angular/forms';
import { CustomValidators } from '@shared/custom-validators';
import { LocaleResourceManager } from '@shared/manager/locale-resource.manager';

@Injectable({providedIn: 'root'})
export class ValidatorFactory {

  private  localeResourceManager = inject(LocaleResourceManager);

  public number(args: {
    min?: number,
    max?: number,
    minError?: string,
    maxError?: string,
    precision?: number | false,
    allowNegative?: boolean,
    optional?: boolean,
  } = {}): ValidatorFn {

    args = {
    ...{
      min: null,
      max: null,
      minError: null,
      maxError: null,
      precision: 1,
      allowNegative: true,
      optional: false,
    },
      ...args
    }

    const numberValidator = CustomValidators.number(
      (value) => this.localeResourceManager.formatNumber(value),
      this.localeResourceManager.getValueByKey('validation.number.thousands_separator'),
      this.localeResourceManager.getValueByKey('validation.number.decimal_separator'),
      args.min,
      args.max,
      args.minError,
      args.maxError,
      args.precision,
      args.allowNegative,
    );

    if (args.optional) {
      return (control) => control.value ? numberValidator(control) : null
    }

    return numberValidator;
  }

}
